import { AdminListMarketsFilter, Market } from '../../graphql/API';
import { OptionEntry } from '../../utils/generate-options';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminListApplicationUsersMarketsAsOptionsApi = async (
  filter: AdminListMarketsFilter,
): Promise<OptionEntry[]> => {
  const result = await executeGql<Market[]>(adminListApplicationUsersMarketsQuery, {
    filter: {
      status: 'active',
      sortBy: 'name',
      sortDirection: 'asc',
      limit: 10000,
      offset: 0,
      ...filter,
    },
  });
  const items = processGqlResult<Market[]>('adminListMarkets.items', result);

  return items.map<OptionEntry>((m: Market) => {
    return {
      key: m.id || '',
      value: `${m.name} (${m.totalApplicationUsers})`,
    };
  });
};

// const adminListVenueLeadsMarketsForOptionsQuery = /* GraphQL */ `
//   query AdminListMarkets {
//     adminListMarkets(
//       filter: {
//         status: active
//         sortBy: "totalVenuesLeads"
//         sortDirection: "desc"
//         limit: 10000
//         offset: 0
//       }
//     ) {
//       items {
//         countryCode
//         id
//         name
//         stateProvince
//         totalVenuesLeads
//       }
//     }
//   }
// `;

export const adminListApplicationUsersMarketsQuery = /* GraphQL */ `
  query AdminListMarkets($filter: AdminListMarketsFilter!) {
    adminListMarkets(filter: $filter) {
      items {
        id
        name
        stateProvince
        countryCode
        country
        totalApplicationUsers
      }
    }
  }
`;
